<template>
  <div id="overlay" ref="overlay">
    <svg width="100%" height="100%">
      <text
              y="10"
              :x="xpos"
              text-anchor="middle"
              style="font-size:x-small"
      >Move to update</text>
      <circle
              r="7"
              :cx="xpos"
              cy="25"
              class="dot"

      ></circle>
    </svg>

  </div>
</template>

<script>

   /**
    * NOTE, the parent element must have css "position: relative" for this to position correctly
    */
   export default {
      name: "overlayHighlight",
      data(){
         return {
            xpos: 10,
            width: 0,

         };
      },
      methods:{
        async animate(){
           for (let i=0; i<5; i++){
              await setTimeout(() => {console.log('overlay wait', i)}, 2000);
              this.xpos -= 10;
           }

        }
      },
      watch:{
         // width(){
         //
         //    console.log('width', this.width)
         //    if (this.width !== null){
         //       this.xpos = this.width*0.65;
         //    }
         //
         //    console.log('xpos', this.xpos)
         //
         //
         // }



      },

      async mounted(){
         // await setTimeout(() => {console.log('overlay wait')}, 3500);
         this.width = this.$refs.overlay.offsetWidth;

         // this.animate();
         this.xpos = this.width*0.6;

         let timer = setInterval(() =>{
            if (this.xpos < this.width*0.4)
               this.xpos = this.width*0.7;
            this.xpos -= 10;
         }, 500)

         setTimeout(() => {
            clearInterval(timer);
            this.$refs.overlay.style="display:none";
         }, 15000)

      },
      updated(){
         this.width = this.$refs.overlay.offsetWidth;
         // this.width = document.getElementById("overlay").offsetWidth;
      }
   }
</script>

<style scoped>

  .dot{

    fill: rgba(147, 107, 255, 0.66);
  }

  #overlay {
    position: absolute; /* Sit on top of the page content */
    /*display: none; !* Hidden by default *!*/
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /*background-color: rgba(0,0,0,0.5); !* Black background with opacity *!*/
    z-index: 0; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
  }

</style>